import {GET_CV_PDF} from "./actionTypes";

export const getCvPdf = ({id, email, needDownload}) => {
    return {
        type: GET_CV_PDF,
        payload: {id, email, needDownload},
    };
};